import CrudCustom from '../../../libs/custom/CrudCustom';

let TipePengecualianPajakService = new CrudCustom('/tipe-pengecualian-pajaks');
export default TipePengecualianPajakService;
